const SAFETY_POINT_MAP = {
  suitable: 'Vyhovuje',
  'not-suitable': 'Nevyhovuje',
  'with-reservations': 'Vyhovuje s výhradami',
};

/**
 * Translates the safety point to a human readable string.
 */
export function translateSafetyPoint(safetyPoint: string | undefined, safetyPointLabel?: string | undefined): string {
  return safetyPointLabel || SAFETY_POINT_MAP[safetyPoint as keyof typeof SAFETY_POINT_MAP] || '';
}
